import React, { useState } from "react";
import image1 from "./images/image1.png";
import image2 from "./images/image2.png";
import image3 from "./images/image3.png";
import vector2 from "./images/group2.svg";
import vector1 from "./images/group3.svg";
import "./Main.css";
import BlurLoader from "../../UI/LazyLoader/BlurLoader";

const LosSection = () => {
  const [loaded, setloaded] = useState(false);

  const StuffLoaded = () => {
    setTimeout(() => {
      setloaded(true);
    }, 6000);
  };
  return (
    <div className="los-section-container">
      <div className="los-section-container-inner">
        <div className="uigrid los-section-box">
          <header className="uigrid-4">
            <h3>Product engineering</h3>
            <p>
              We develop web and mobile products, mainly in ecommerce and
              payments. Selected partner projects where a product needs to be
              built or extended by an experienced team.
            </p>
          </header>
          <div className="uigrid-6 los-section-box-img-container">
            {!loaded && <BlurLoader />}
            <img
              className="los-section-box-img"
              src={image1}
              alt="/"
              onLoad={StuffLoaded}
            />
            <img className="span-vector" src={vector1} alt="/" />
          </div>
        </div>
        <div className="uigrid los-section-box">
          <div className="uigrid-6 los-section-middle-img">
            {!loaded && <BlurLoader />}
            <img
              className="los-section-box-img"
              src={image2}
              alt="/"
              onLoad={StuffLoaded}
            />
            <img className="middle-vector" src={vector2} alt="/" />
          </div>
          <header className="uigrid-4 los-section-middle-text">
            <h3>Product design</h3>
            <p>
              UX and UI for commerce products: onboarding, checkout, admin
              dashboards, and mobile apps.
            </p>
          </header>
        </div>
        <div className="uigrid los-section-box">
          <header className="uigrid-4">
            <h3>Web and mobile apps</h3>
            <p>
              Customer-facing apps and merchant tools, built to integrate with
              payments, inventory, and operations backends.
            </p>
          </header>
          <div className="uigrid-6 los-section-box-img-container">
            {!loaded && <BlurLoader />}
            <img
              className="los-section-box-img"
              src={image3}
              alt="/"
              onLoad={StuffLoaded}
            />
            <img className="span-vector" src={vector1} alt="/" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LosSection;
